module.exports = __webpack_public_path__ + "vue/img/video.eba1edcb.png";